import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { withRouter } from 'react-router-dom';
import { SgProductService, SgSessionStorageService } from 'saga-modules';
import CommonConstants from 'sg-common-constants';
import { StringUtil } from 'gw-portals-util-js';
import { Link } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import styles from 'sg-portals-wizard-react/Wizard/templates/SgWizardPageTemplate.module.scss';
import messages from './SecciPage.messages';

function SecciPage() {
    const aprRate = SgSessionStorageService.getItem(SgSessionStorageService.KEY.APR);
    const interestCharge = SgSessionStorageService.getItem(SgSessionStorageService.KEY.INTEREST_CHARGE);
    const interestChargeFormatted = interestCharge === '0' ? interestCharge : parseFloat(interestCharge).toFixed(1);
    const registerNumber = appConfig.secciRegisterNumber;
    const emailAddress = appConfig.secciEmailAddress;
    const productName = StringUtil.capitalizeFirstLetter(SgProductService.getProduct());
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const contactUsPhoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_IPID_OTHER_PHONE_NUMBER;
    const aprRateCapApplied = SgSessionStorageService.getItem(SgSessionStorageService.KEY.DD_APR_CAP) === 'true';

    return (
        <div className={styles.digitalWizard}>
            <div className={`${styles.wizardMain} sgWizardMainLayout`}>
                <div className="secci">
                    <h1 className="sg-page-section-title-important-statements">{translator(messages.Header)}</h1>
                    <p className="page-summary">{translator(messages.SubHeader)}</p>
                    <h2 className="secciTitles">
                        {translator(messages.HeaderContactDetails)}
                    </h2>
                    <table>
                        <tbody>
                            <tr>
                                <td className="left">{translator(messages.ContactDetailsHeader1)}</td>
                                <td>{translator(messages.ContactDetailsValue1)}</td>
                            </tr>
                            <tr>
                                <td className="left">{translator(messages.ContactDetailsHeader2)}</td>
                                <td>{translator(messages.ContactDetailsValue2)}</td>
                            </tr>
                            <tr>
                                <td className="left">{translator(messages.ContactDetailsHeader3)}</td>
                                <td>
                                    { isMobile
                                        ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                                        : contactUsPhoneNumber
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="left">{translator(messages.ContactDetailsHeader4)}</td>
                                <td>
                                    <Link href="mailto:{{emailAddress | translate}}">{emailAddress}</Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h2 className="secciTitles">
                        {translator(messages.HeaderKeyFeatures)}
                    </h2>
                    { !isMobile && (
                        <table>
                            <tbody>
                                <tr>
                                    <td className="left">
                                        <b>{translator(messages.KeyFeaturesHeader1)}</b>
                                    </td>
                                    <td>{translator(messages.KeyFeaturesValue1)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader2)}</td>
                                    <td>{translator(messages.KeyFeaturesValue2)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader3)}</td>
                                    <td>{translator(messages.KeyFeaturesValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader4)}</td>
                                    <td>{translator(messages.KeyFeaturesValue4)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader5)}</td>
                                    <td>{translator(messages.KeyFeaturesValue5)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader6)}</td>
                                    <td>
                                        <ul>
                                            <li>{translator(messages.KeyFeaturesValue6a)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6b)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6c)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6d)}</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.KeyFeaturesHeader7)}</td>
                                    <td>
                                        <p>{translator(messages.KeyFeaturesValue7a)}</p>
                                        <p>{translator(messages.KeyFeaturesValue7b, { productName: productName })}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    { isMobile && (
                        <table className="sgSecciTableMobile">
                            <tbody>
                                <tr>
                                    <td className="heading">
                                        <b>{translator(messages.KeyFeaturesHeader1)}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.KeyFeaturesValue1)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader2)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.KeyFeaturesValue2)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader3)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.KeyFeaturesValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader4)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.KeyFeaturesValue4)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader5)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.KeyFeaturesValue5)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader6)}</td>
                                </tr>
                                <tr>
                                    <td className="details">
                                        <ul>
                                            <li>{translator(messages.KeyFeaturesValue6a)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6b)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6c)}</li>
                                            <li>{translator(messages.KeyFeaturesValue6d)}</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.KeyFeaturesHeader7)}</td>
                                </tr>
                                <tr>
                                    <td className="details">
                                        <p>{translator(messages.KeyFeaturesValue7a)}</p>
                                        <p>{translator(messages.KeyFeaturesValue7b, { productName: productName })}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <h2 className="secciTitles">
                        {translator(messages.HeaderCostOfTheCredit)}
                    </h2>
                    { !isMobile && (
                        <table>
                            <tbody>
                                <tr>
                                    <td className="left">{translator(messages.CostsHeader1)}</td>
                                    <td>
                                        {translator(messages.CostsValue1, { rate: interestChargeFormatted })}
                                        { aprRateCapApplied && translator(messages.CostsValue3)}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.CostsHeader2)}</td>
                                    <td id={aprRate}>{translator(messages.CostsValue2, { apr: aprRate })}</td>
                                </tr>
                                <tr>
                                    <td colSpan="2" className="left highlighted">
                                        <b>{translator(messages.CostsHeader3)}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.CostsHeader4)}</td>
                                    <td>{translator(messages.CostsValue4)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.CostsHeader5)}</td>
                                    <td>{translator(messages.CostsValue5)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    { isMobile && (
                        <table className="sgSecciTableMobile">
                            <tbody>
                                <tr>
                                    <td className="heading">{translator(messages.CostsHeader1)}</td>
                                </tr>
                                <tr>
                                    <td className="details">
                                        {translator(messages.CostsValue1, { rate: interestChargeFormatted })}
                                        { aprRateCapApplied && translator(messages.CostsValue3)}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.CostsHeader2)}</td>
                                </tr>
                                <tr>
                                    <td className="details" id={aprRate}>{translator(messages.CostsValue2, { apr: aprRate })}</td>
                                </tr>
                                <tr>
                                    <td className="highlighted">{translator(messages.CostsHeader3)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.CostsHeader4)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.CostsValue4)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.CostsHeader5)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.CostsValue5)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <h2 className="secciTitles">
                        {translator(messages.HeaderLegalAspects)}
                    </h2>
                    { !isMobile && (
                        <table>
                            <tbody>
                                <tr>
                                    <td className="left">{translator(messages.OtherLegalAspectsHeader1)}</td>
                                    <td>{translator(messages.OtherLegalAspectsValue1)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.OtherLegalAspectsHeader2)}</td>
                                    <td>{translator(messages.OtherLegalAspectsValue2)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.OtherLegalAspectsHeader3)}</td>
                                    <td>{translator(messages.OtherLegalAspectsValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.OtherLegalAspectsHeader4)}</td>
                                    <td>{translator(messages.OtherLegalAspectsValue4)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    { isMobile && (
                        <table className="sgSecciTableMobile">
                            <tbody>
                                <tr>
                                    <td className="heading">{translator(messages.OtherLegalAspectsHeader1)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.OtherLegalAspectsValue1)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.OtherLegalAspectsHeader2)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.OtherLegalAspectsValue2)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.OtherLegalAspectsHeader3)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.OtherLegalAspectsValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.OtherLegalAspectsHeader4)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.OtherLegalAspectsValue4)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <h2 className="secciTitles">
                        {translator(messages.HeaderAdditionalInformation)}
                    </h2>
                    { !isMobile && (
                        <table>
                            <tbody>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader1)}</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader2)}</td>
                                    <td>{translator(messages.AdditionalInformationValue2, { number: registerNumber })}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader3)}</td>
                                    <td>{translator(messages.AdditionalInformationValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader4)}</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader5)}</td>
                                    <td>{translator(messages.AdditionalInformationValue5)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader6)}</td>
                                    <td>{translator(messages.AdditionalInformationValue6)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader7)}</td>
                                    <td>{translator(messages.AdditionalInformationValue7)}</td>
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader8)}</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td className="left">{translator(messages.AdditionalInformationHeader9)}</td>
                                    <td>{translator(messages.AdditionalInformationValue9)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    { isMobile && (
                        <table className="sgSecciTableMobile">
                            <tbody>
                                <tr>
                                    <td className="highlighted">{translator(messages.AdditionalInformationHeader1)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader2)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue2, { number: registerNumber })}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader3)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue3)}</td>
                                </tr>
                                <tr>
                                    <td className="highlighted">{translator(messages.AdditionalInformationHeader4)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader5)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue5)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader6)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue6)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader7)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue7)}</td>
                                </tr>
                                <tr>
                                    <td className="highlighted">{translator(messages.AdditionalInformationHeader8)}</td>
                                </tr>
                                <tr>
                                    <td className="heading">{translator(messages.AdditionalInformationHeader9)}</td>
                                </tr>
                                <tr>
                                    <td className="details">{translator(messages.AdditionalInformationValue9)}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
export default withRouter(SecciPage);
